export default (function (_ref) {
  var request = _ref.request;
  return {
    ledParamAdd: function ledParamAdd(data) {
      return request({
        url: '/iot/ledParam/add',
        method: 'post',
        data: data
      });
    },
    ledParamModify: function ledParamModify(data) {
      return request({
        url: "/iot/ledParam/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    ledParamDel: function ledParamDel(id) {
      return request({
        url: "/iot/ledParam/".concat(id, "/del"),
        method: 'delete'
      });
    },
    ledParamQuery: function ledParamQuery(data) {
      return request({
        url: '/iot/ledParam/query',
        method: 'get',
        params: data
      });
    },
    ledParamDetail: function ledParamDetail(id) {
      return request({
        url: "/iot/ledParam/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});